import { render } from "./ModuleCard.vue?vue&type=template&id=6825d608&scoped=true"
import script from "./ModuleCard.vue?vue&type=script&lang=js"
export * from "./ModuleCard.vue?vue&type=script&lang=js"

import "./ModuleCard.vue?vue&type=style&index=0&id=6825d608&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6825d608"]])

export default __exports__